import { Curtain } from '../../../components/curtain/Curtain';
import { PopupType } from '../../../components/popup/types';
import { gameStateActions } from '../../../store/slices/game/slice';
import { initializationActions } from '../../../store/slices/initialization/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

export class CoreTerminateSessionProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.TerminateSession;
  public delay = 0;

  public process(): void {
    Curtain.resurrect();
    this.store.dispatch(popupActions.overwritePopup(PopupType.SessionTerminated));
    this.store.dispatch(gameStateActions.setGameAbandoned(true));
    this.store.dispatch(initializationActions.setIsReadyToRender(false));
  }
}
